/* eslint-disable react/no-array-index-key */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Carousel, { Modal, ModalGateway } from 'react-images';

export default class ProfileGallery extends PureComponent {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
    })).isRequired,
  };

  constructor() {
    super();
    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
      currentImagePreview: 0,
      brokenImages: new Set(),
    };
  }

  handleBrokenImage = (src) => {
    this.setState(prev => {
      const brokenImages = new Set(prev.brokenImages);
      brokenImages.add(src);
      return { brokenImages };
    });
  };

  changeImg = (i, e) => {
    e.preventDefault();
    this.setState({
      currentImagePreview: i,
      currentImage: i,
    });
  };

  openLightbox = (index, event) => {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  };

  closeLightbox = () => {
    this.setState(prevState => ({ currentImage: prevState.currentImagePreview, lightboxIsOpen: false }));
  };

  gotoPrevious = () => {
    this.setState(prevState => ({ currentImage: prevState.currentImage - 1 }));
  };

  gotoNext = () => {
    this.setState(prevState => ({ currentImage: prevState.currentImage + 1 }));
  };

  gotoImage = (index) => {
    this.setState({
      currentImage: index,
    });
  };

  handleClickImage = () => {
    const { images } = this.props;
    const { currentImage } = this.state;
    if (currentImage === images.length - 1) return;
    this.gotoNext();
  };

  render() {
    const { button } = this.props;
    const { currentImage, currentImagePreview, lightboxIsOpen, brokenImages } = this.state;
    const images = this.props.images.filter(img => !brokenImages.has(img.src));
    const safeCurrentImage = Math.min(currentImage, Math.max(0, images.length - 1));
    const safeCurrentPreview = Math.min(currentImagePreview, Math.max(0, images.length - 1));
    const slice = 4;
    const fpPos = false;
    return (
      <div className="product-gallery">
      	{button}
        <a
          className="product-gallery__current-img"
          onClick={e => this.openLightbox(safeCurrentImage, e)}
          href={images.length > 0 ? images[safeCurrentImage].src : null}
        >
        {images.length > 0 && images[safeCurrentPreview].src.indexOf('googleapis')>=0 ?
	      <img src={`${images[safeCurrentPreview].src}`} onError={() => this.handleBrokenImage(images[safeCurrentPreview].src)} />
	      :
          <div style={{ backgroundImage : `url("${images.length > 0 ? images[safeCurrentPreview].src : ''}")` }} className="product-img" />
        }
        </a>
        {images.length > 0 &&
        <div className="product_gallery__gallery">
          {images.length > 5 ?
          <Fragment>  
            
           {images.slice(0,slice).map((img, i) => (
              <button type="button" key={i} onClick={e => this.openLightbox(i, e)} className="product-gallery__img-preview">
                <img src={img.src} alt="product-img" onError={() => this.handleBrokenImage(img.src)} />
              </button>
             ))}
             <button type="button" key={5} onClick={e => this.openLightbox(slice, e)} className="product-gallery__img-preview preview-more" style={{backgroundImage:`url(${images[slice].src})`}}>
                <span>+ {images.length-slice}</span>
             </button> 
             {fpPos &&
              <button type="button" key={fpPos} onClick={e => this.openLightbox(fpPos, e)} className="product-gallery__img-preview">
                <img src={images[fpPos].src} alt="product-img" />
             </button> 
               
             }
           </Fragment>  	       
         :
         <Fragment>  
           {images.map((img, i) => (
              <button type="button" key={i} onClick={e => this.openLightbox(i, e)} className="product-gallery__img-preview">
                <img src={img.src} alt="product-img" onError={() => this.handleBrokenImage(img.src)} />
              </button>
             ))}
           </Fragment>
          }
        </div>
        }
        <ModalGateway>
        {lightboxIsOpen ? (
          <Modal onClose={this.closeLightbox}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
     {/*   <Lightbox
          currentImage={currentImage}
          views={images}
          isOpen={lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
        /> */}
      </div>
    );
  }
}
